import { object, string } from 'yup'

export const detail = {
  columnSiapaTerlibat: [
    {
      Header: 'No',
      accessor: 'no',
      width: '5%',
    },
    {
      Header: 'Nama Personel',
      accessor: 'namaPersonel',
    },
    {
      Header: 'Unit Kerja',
      accessor: 'unitDivisi',
    },
  ],

  columnKapanTerjadi: [
    {
      Header: 'No',
      accessor: 'no',
      width: '5%',
    },
    {
      Header: 'Tanggal',
      accessor: 'tanggal',
    },
    {
      Header: 'Keterangan',
      accessor: 'keterangan',
    },
  ],

  columnDokumenPendukung: [
    {
      Header: 'No',
      accessor: 'num',
      width: '5%',
    },
    {
      Header: 'Nama File',
      accessor: 'fileName',
    },
    {
      Header: 'Timestamp',
      accessor: 'timestamp',
    },
    {
      Header: 'Jenis file',
      accessor: 'jenisFile',
    },
    {
      Header: 'Keterangan',
      accessor: 'notes',
    },
  ],
}

export const logo =
  'https://www.pinclipart.com/picdir/big/18-185559_winter-cardinal-bird-clipart-clip-art-library-classroom.png'

export const dummySelection = [
  {
    code: '',
    value: '-Pilih-',
  },
]

export type InsidePanelCompProps = {
  state?: string
  handleModal?: any
  data?: any
  checkedItems?: boolean[]
  setCheckedItems?: any
  setDetailId?: any
}

export const initialValues = {
  namaPersonel: '',
  unitDivisi: '',
  waktuKejadian: '',
  keterangan: '',
  buktiPendukung: '',
  description: '',
}

export const validationSchema = object().shape({
  jenisPengaduan: string().required('Field ini wajib diisi'),
  apaYangTerjadi: string().trim().required('Field ini wajib diisi'),
})
